import React from 'react'
import Navbar from '../inc/Navbar';
import AddBook from "../AddBook";
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import ContactForm from './ContactFrom';


function Contactform() {
  return (
    <div>
      <Navbar />
      <br />
      <br />

      <br />

      <br>
      </br>
      <ScrollToTop smooth top="100" color="Gray" />
      <div className='websitedevelopkrishnagar'>
        <div className="album py-2">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className='contactback'>
        <br />
        <div className="album py-2">

          <div className="container">
            <div className='card'>
              <div class="card-body">
                <center>
                   <h4 style={{color:"#553C1E"}}>Contact <b>MR. INDIAN CODER </b></h4>
                   </center>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>
  )
}

export default Contactform